
































import { computed, defineComponent, toRef } from '@vue/composition-api';
import { LoadingIcon, ErrorCircleIcon } from 'tdesign-icons-vue';
import ipc from '@/renderer/scripts/utils/ipc';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default defineComponent({
  components: {
    LoadingIcon,
    ErrorCircleIcon,
  },
  props: {
    showLoading: {
      required: true,
      type: Boolean,
      default: false,
    },
    showFail: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    //
    const showLoading = toRef(props, 'showLoading');
    const showFail = toRef(props, 'showFail');
    const innerShow = computed(() => showLoading.value || showFail.value);
    const methods = {
      reset() {
        context.emit('reset');
      },
      restart() {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.RESTART);
      },
    };
    return {
      ...methods,
      innerShow,
      appUrl: CONSTANT_URL.appUrl,
    };
  },
});
